module.exports = __webpack_public_path__ + "48dce86a7ce5359c37a648eccf4abe85.png";